import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink-950 px-4 py-12 sm:py-16" data-id="element-88" data-mp="x53cyzs363aq">
      <div className="mx-auto max-w-2xl" data-id="element-89" data-mp="1223gp41gqtyo">
        <h2 className="text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-90" data-mp="12353g5rud4w8">
          Domande Frequenti
        </h2>

        <div className="mt-7 space-y-2.5" data-id="element-91" data-mp="1urao6siwatw2">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-white/10 bg-ink-900" data-id="element-92" data-mp="1g1mp7xy6s7bi" data-mpi={i}>
                <h3 data-id="element-93" data-mp="28r21er1l8690">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left transition-colors duration-150 ease-out hover:bg-ink-800" data-id="element-94" data-mp="28qjyxcoc0vsn">
                    <span className="text-[14.5px] font-bold leading-snug text-white" data-id="element-95" data-mp="2jsyw6osez3ew">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-96" data-mp="2tos763qhiouk" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-white/5 px-4 py-3.5 text-[13.5px] leading-relaxed text-white/65" data-id="element-97" data-mp="3hctjzoup4rfs">
                    {faq.a}
                  </p>}
              </div>;
        })}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-98" data-mp="1i2bmvgy8g9ow">
          <CTAButton label="Ho tutte le risposte, voglio iniziare" sublabel="Garanzia di 7 giorni" data-id="element-99" data-mp="1i3mrtk3eznhl" />
        </div>
      </div>
    </section>;
}